import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { SuperAdminProvider } from "./SuperAdminContext";
import SuperAdminDashboard from "./SuperAdminDashboard";
import SuperAdminLogin from "./SuperAdminLogin";
import SuperAdminSetup from "./SuperAdminSetup";
import CompanyDetailPage from "./pages/CompanyDetailPage";

export default function SuperAdminApp() {
  return (
    <SuperAdminProvider>
      <Routes>
        <Route path="login" element={<SuperAdminLogin />} />
        <Route path="setup" element={<SuperAdminSetup />} />
        <Route path="companies/:companyId" element={<CompanyDetailPage />} />
        <Route path="" element={<SuperAdminDashboard />} />
        <Route path="*" element={<Navigate to="" replace />} />
      </Routes>
    </SuperAdminProvider>
  );
}
